var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { DATE_PICKER_FORMAT, SERVER_TIMEZONE } from '../../../../constants';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrBefore);
export var IsWithinMaxDate = function (date, _a) {
    var maxAdvanceDuration = _a.maxAdvanceDuration;
    var _b = __read(maxAdvanceDuration, 2), maxAdvancedValue = _b[0], maxAdvancedUnit = _b[1];
    var maxDate = dayjs()
        .tz(SERVER_TIMEZONE)
        .add(maxAdvancedValue, maxAdvancedUnit);
    return dayjs
        .tz(date, DATE_PICKER_FORMAT, SERVER_TIMEZONE)
        .isSameOrBefore(maxDate, 'day');
};
//# sourceMappingURL=IsWithinMaxDate.js.map